import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CombinationColor } from '@/redux/back-dashboard-api';
import { COLORS } from '@/lib/constants';
import styles from './index.module.css';

const COLOR_MAP = COLORS.reduce((acc, color) => {
  acc[color.value] = {
    id: color.value,
    className: styles[`color__circle--${color.value.toLowerCase()}`],
    i18nKey: `label.colorNames.${color.value.toLowerCase()}`,
  };
  return acc;
}, {} as Record<CombinationColor, { id: CombinationColor; className: string; i18nKey: string }>);

export const ColorPicker: FC<{
  colors: Set<CombinationColor>;
  selected?: CombinationColor;
  onChange: (color: CombinationColor) => void;
}> = ({ colors, selected, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles['color__container']}>
      {[...colors]
        .map((key) => COLOR_MAP[key])
        .map(({ id, className, i18nKey }) => (
          <div
            key={i18nKey}
            className="flex flex-col justify-start cursor-pointer"
            // onChange={() => onChange(id)}
            // onClick={() => onChange(id)}
          >
            <input
              id={id}
              name={t(i18nKey)}
              type="checkbox"
              className={styles['color__input']}
              onChange={() => onChange(id)}
              checked={selected === id}
            />

            <label htmlFor={id} className={styles['color__label']}>
              <div className="flex rounded bg-white border border-gray-300 w-[48px] h-[48px]">
                <div className={`${className} ${styles['color__circle']}`} />
              </div>

              {/* <span>{t(i18nKey)}</span> */}
            </label>
          </div>
        ))}
    </div>
  );
};
